import * as Types from '../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type PreviewCheckoutQueryVariables = Types.Exact<{
  enterpriseId: Types.Scalars['UUID'];
  customerId?: Types.InputMaybe<Types.Scalars['UUID']>;
  contact?: Types.InputMaybe<Types.ContactInput>;
  address: Types.AddressInput;
  invoiceAddress?: Types.InputMaybe<Types.AddressInput>;
  items: Array<Types.CartItemInput> | Types.CartItemInput;
  comment?: Types.InputMaybe<Types.Scalars['String']>;
  discountParams?: Types.InputMaybe<Types.DiscountParamsInput>;
}>;

export type PreviewCheckoutQuery = {
  __typename?: 'Query';
  previewCheckout: {
    __typename?: 'CalculatedOrderItemsWithTotal';
    total: number;
    netTotal?: number | null;
    grossTotal?: number | null;
    taxes?: Array<{
      __typename?: 'TaxInfo';
      taxRate: number;
      amount: number;
    }> | null;
    items: Array<
      | {
          __typename?: 'CalculatedBookingOrderItem';
          title: string;
          verboseTitle?: string | null;
          quantity: number;
          amount?: number | null;
          netAmount?: number | null;
          originalAmount?: number | null;
          taxRate: number;
          discounts: Array<{
            __typename?: 'Discount';
            amount?: number | null;
            type: Types.DiscountType;
            reason?: string | null;
          }>;
          courseUnit?: {
            __typename?: 'CourseUnit';
            course: { __typename?: 'Course'; displayNetAmount: boolean };
          } | null;
          courseModule?: {
            __typename?: 'CourseModule';
            courseUnit: {
              __typename?: 'CourseUnit';
              course: { __typename?: 'Course'; displayNetAmount: boolean };
            };
          } | null;
        }
      | {
          __typename?: 'CalculatedCustomOrderItem';
          title: string;
          description?: string | null;
          description2?: string | null;
          quantity: number;
          amount?: number | null;
          netAmount?: number | null;
          originalAmount?: number | null;
          taxRate: number;
          discounts: Array<{
            __typename?: 'Discount';
            amount?: number | null;
            type: Types.DiscountType;
            reason?: string | null;
          }>;
        }
      | {
          __typename?: 'CalculatedDiscountOrderItem';
          title: string;
          quantity: number;
          amount?: number | null;
          taxRate: number;
        }
      | {
          __typename?: 'CalculatedPackageBookingOrderItem';
          title: string;
          verboseTitle?: string | null;
          quantity: number;
          amount?: number | null;
          netAmount?: number | null;
          originalAmount?: number | null;
          taxRate: number;
          discounts: Array<{
            __typename?: 'Discount';
            amount?: number | null;
            type: Types.DiscountType;
            reason?: string | null;
          }>;
          package: { __typename?: 'Package'; displayNetAmount: boolean };
        }
      | {
          __typename?: 'CalculatedProductOrderItem';
          title: string;
          verboseTitle?: string | null;
          description2?: string | null;
          startDate?: any | null;
          endDate?: any | null;
          quantity: number;
          amount?: number | null;
          netAmount?: number | null;
          originalAmount?: number | null;
          taxRate: number;
          discounts: Array<{
            __typename?: 'Discount';
            amount?: number | null;
            type: Types.DiscountType;
            reason?: string | null;
          }>;
          product:
            | { __typename?: 'LocationProduct'; displayNetAmount: boolean }
            | { __typename?: 'SimpleProduct'; displayNetAmount: boolean };
        }
    >;
    globalDiscounts: Array<{
      __typename?: 'Discount';
      type: Types.DiscountType;
      amount?: number | null;
      reason?: string | null;
    }>;
  };
};

export const PreviewCheckoutDocument = gql`
  query PreviewCheckout(
    $enterpriseId: UUID!
    $customerId: UUID
    $contact: ContactInput
    $address: AddressInput!
    $invoiceAddress: AddressInput
    $items: [CartItemInput!]!
    $comment: String
    $discountParams: DiscountParamsInput
  ) {
    previewCheckout(
      enterpriseId: $enterpriseId
      customerId: $customerId
      contact: $contact
      address: $address
      invoiceAddress: $invoiceAddress
      items: $items
      comment: $comment
      discountParams: $discountParams
    ) {
      total
      netTotal
      grossTotal
      taxes {
        taxRate
        amount
      }
      items {
        ... on CalculatedBookingOrderItem {
          title
          verboseTitle
          quantity
          amount
          netAmount
          originalAmount
          taxRate
          discounts {
            amount
            type
            reason
          }
          courseUnit {
            course {
              displayNetAmount
            }
          }
          courseModule {
            courseUnit {
              course {
                displayNetAmount
              }
            }
          }
        }
        ... on CalculatedProductOrderItem {
          title
          verboseTitle
          description2
          startDate
          endDate
          quantity
          amount
          netAmount
          originalAmount
          taxRate
          discounts {
            amount
            type
            reason
          }
          product {
            ... on SimpleProduct {
              displayNetAmount
            }
            ... on LocationProduct {
              displayNetAmount
            }
          }
        }
        ... on CalculatedDiscountOrderItem {
          title
          quantity
          amount
          taxRate
        }
        ... on CalculatedCustomOrderItem {
          title
          description
          description2
          quantity
          amount
          netAmount
          originalAmount
          taxRate
          discounts {
            amount
            type
            reason
          }
        }
        ... on CalculatedPackageBookingOrderItem {
          title
          verboseTitle
          quantity
          amount
          netAmount
          originalAmount
          taxRate
          discounts {
            amount
            type
            reason
          }
          package {
            displayNetAmount
          }
        }
      }
      globalDiscounts {
        type
        amount
        reason
      }
    }
  }
`;
export type PreviewCheckoutComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    PreviewCheckoutQuery,
    PreviewCheckoutQueryVariables
  >,
  'query'
> &
  (
    | { variables: PreviewCheckoutQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const PreviewCheckoutComponent = (
  props: PreviewCheckoutComponentProps,
) => (
  <ApolloReactComponents.Query<
    PreviewCheckoutQuery,
    PreviewCheckoutQueryVariables
  >
    query={PreviewCheckoutDocument}
    {...props}
  />
);

/**
 * __usePreviewCheckoutQuery__
 *
 * To run a query within a React component, call `usePreviewCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewCheckoutQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *      customerId: // value for 'customerId'
 *      contact: // value for 'contact'
 *      address: // value for 'address'
 *      invoiceAddress: // value for 'invoiceAddress'
 *      items: // value for 'items'
 *      comment: // value for 'comment'
 *      discountParams: // value for 'discountParams'
 *   },
 * });
 */
export function usePreviewCheckoutQuery(
  baseOptions: Apollo.QueryHookOptions<
    PreviewCheckoutQuery,
    PreviewCheckoutQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PreviewCheckoutQuery, PreviewCheckoutQueryVariables>(
    PreviewCheckoutDocument,
    options,
  );
}
export function usePreviewCheckoutLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PreviewCheckoutQuery,
    PreviewCheckoutQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PreviewCheckoutQuery,
    PreviewCheckoutQueryVariables
  >(PreviewCheckoutDocument, options);
}
export type PreviewCheckoutQueryHookResult = ReturnType<
  typeof usePreviewCheckoutQuery
>;
export type PreviewCheckoutLazyQueryHookResult = ReturnType<
  typeof usePreviewCheckoutLazyQuery
>;
export type PreviewCheckoutQueryResult = Apollo.QueryResult<
  PreviewCheckoutQuery,
  PreviewCheckoutQueryVariables
>;
